import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { SarlaftStateCaseProps } from './props';
import { useSarlaftStateCase } from './hook';
import { Dialog } from '../../../../../components/general/dialog/dialog';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftStateCase = (props: SarlaftStateCaseProps) => {
    const { formik, status, isUnusualOperation, handleClose } =
        useSarlaftStateCase(props);

    return (
        <>
            <Grid item xs={12} md={4}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Estado del caso
                </Typography>
                <br />
                <AutocompleteField
                    data={formatParams(status)}
                    label="Estado del caso"
                    name="caseStatus"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.caseStatus}
                    errors={formik.errors.caseStatus}
                    value={formik.values.caseStatus}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('caseStatus', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={12}>
                <FieldText
                    label="Observaciones estado del caso"
                    name="observation"
                    rows={6}
                    onBlur={formik.handleBlur}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                    errors={formik.errors.observation}
                />
            </Grid>
            {isUnusualOperation && (
                <Dialog
                    title="Apreciado Cliente"
                    open={isUnusualOperation}
                    onClose={handleClose}
                    maxWidth="md"
                >
                    <Typography>
                        <p>
                            Debido a que su caso corresponde a una operación
                            inusual, le solicitamos enviar un mensaje al correo
                            electrónico
                            <strong> riesgo@previsora.gov.co</strong> con la
                            siguiente información:
                        </p>
                        <ul>
                            <li>Nombre completo:</li>
                            <li>Número de identificación:</li>
                            <li>Ciudad de nacimiento:</li>
                            <li>Ciudad de residencia:</li>
                            <li>Ocupación:</li>
                            <li>Entidad donde labora:</li>
                            <li>
                                Información financiera:
                                <ul>
                                    <li>Ingresos: </li>
                                    <li>Egresos: </li>
                                    <li>Activos/total patrimonio bruto: </li>
                                    <li>Pasivos: </li>
                                </ul>
                            </li>
                        </ul>
                        <p>Además, deberá adjuntar su declaración de renta.</p>
                    </Typography>
                </Dialog>
            )}
        </>
    );
};
